import { useState, type FormEvent } from "react";
import { Button } from "../../components/ui/Button";
import { FormError } from "../../components/ui/Banner";
import { useAction } from "../../hooks/useAction";
import { authApi } from "../../lib/api/auth";
import { CodeField } from "./fields";
import { ResendButton } from "./ResendButton";

/** Second step of sign-up (and of signing in to an unconfirmed account): type the emailed code. */
export function VerifyEmail({ email, onVerified }: { email: string; onVerified: () => Promise<unknown> }) {
  const [otp, setOtp] = useState("");
  const verify = useAction(async () => { await authApi.verifyEmail(email, otp); await onVerified(); });

  const submit = (e: FormEvent) => { e.preventDefault(); void verify.run(); };
  return (
    <form onSubmit={submit} className="flex flex-col gap-4.5">
      <p className="text-muted">Confirm your email to finish.</p>
      <CodeField email={email} accountExists value={otp} onChange={setOtp} />
      <FormError message={verify.error} />
      <Button type="submit" variant="primary" pending={verify.pending} pendingLabel="checking…">confirm email →</Button>
      <ResendButton onResend={() => authApi.sendCode(email, "email-verification")} />
    </form>
  );
}
